<div
  class="c-search-input"
  [class.c-search-input--focused]="isFocused || searchInput.value">
  <div class="c-search-input__icon">
    <ng-content select="[icon]"></ng-content>
  </div>

  <input
    #searchInput
    type="text"
    autocomplete="off"
    [attr.autofocus]="autofocus ? '' : null"
    (focus)="isFocused = true"
    (blur)="isFocused = false; blurInput.emit()"
    (keyup)="valueChange.emit(searchInput.value)" />

  <label>{{ label }}</label>

  <div class="c-search-input__line"></div>
</div>
